
import { computed, defineComponent, onMounted, reactive } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'
import OkModal from '@/modules/OktellModule/components/OkModal/index.vue'
import OkInput from '@/modules/OktellModule/components/OkInput/index.vue'
import OkTable from '@/modules/OktellModule/components/OkTable/index.vue'

import { OktellCreateWaitListParams, OktellWaitListItem } from '@/core/types/oktell.types'

import { oktell } from '@/core/realisations/oktell.realisation'

import {
    OKTELL_WAITLIST_STATUSES_WITH_DATE,
    OKTELL_WAITLIST_INPUTS_WITH_DATE,
} from '@/core/constants/oktell.constants'

import { useRoute } from 'vue-router'
import useNotifications from '@/common/composable/useNotifications'

import penIcon from '@/assets/icons/pen.svg'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

const COLUMNS = [
    {
        name: 'Статус ЛО',
        key: 'title',
    },
    {
        name: 'Дата',
        key: 'actions',
    },
    {
        name: 'Номер забора',
        key: 'number',
    },
    {
        name: 'Комментарий',
        key: 'comment',
    },
    {
        name: 'Подтвердить',
        key: 'accept',
    },
    {
        name: 'Отказ',
        key: 'decline',
    },
]

export default defineComponent({
    components: {
        Loader,
        OkButton,
        OkModal,
        OkInput,
        penIcon,
        OkTable,
    },
    emits: ['date'],
    setup() {
        const route = useRoute()
        const notifications = useNotifications()
        const phone = route.query.phone as string | undefined
        const callCenterEmail = route.query.email as string | undefined

        const state = reactive({
            is_loading: false,
            is_manage_loading: false,
            is_failed: false,
            invalid_item_id: null as number | null,
            is_invalid_date: false,
            list: [] as OktellWaitListItem[],
            comments: [] as string[],
        })

        const state_date = reactive({
            is_open: false,
            date: null as string | null,
        })

        const state_form$ = useVuelidate(
            {
                date: { required },
            },
            state_date
        )

        // const openDate = (item: OktellWaitListItem) => {
        //     state_date.date = item.value
        //     state_date.is_open = true
        // }

        // const confirmDate = () => {
        //     state_form$.value.$touch()
        //     if (state_form$.value.$invalid) return

        //     state_date.is_open = false
        // }

        const closeDate = () => {
            state_date.is_open = false
            state_date.date = null
        }

        const loadWaitList = async () => {
            if (!phone) return

            try {
                state.is_loading = true

                const response = await oktell.getWaitList({ phone: phone as string })
                state.list = response.data

                const length = state.list.length
                state.comments = new Array(length).fill(null)

                state.is_failed = false
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При загрузке листа ожидания произошла ошибка',
                })
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const getPayloadWaitList = (
            item: OktellWaitListItem,
            type?: string
        ): OktellCreateWaitListParams => {
            const payload: OktellCreateWaitListParams = {
                code: item.status.code,
                stateId: 49,
                value: item.value,
                comment: state.comments[state.list.indexOf(item)],
                source: 'ARM',
                parentId: item.id,
                callCenterEmail: callCenterEmail,
            }

            if (item.clientTypeId === 1) {
                payload.invoiceId = item.clientId
            } else if (item.clientTypeId === 2) {
                payload.orderId = item.clientId
            }

            if (type === 'submit') {
                payload.stateId = 48
            }

            return payload
        }

        const manageAnswer = async (item: OktellWaitListItem, type?: string) => {
            state.invalid_item_id = null
            state.is_invalid_date = false

            if (item.status) {
                if (
                    OKTELL_WAITLIST_INPUTS_WITH_DATE.includes(item.status.code) &&
                    type === 'submit' &&
                    !item.value
                ) {
                    state.invalid_item_id = item.id
                    state.is_invalid_date = true
                    notifications.notify({ type: 'danger', title: 'Пожалуйста, заполните дату!' })
                    return
                }
            }

            try {
                state.is_manage_loading = true

                const payload = getPayloadWaitList(item, type)
                await oktell.createWaitList(payload)

                closeDate()
                loadWaitList()
                notifications.notify({ title: 'Ответ успешно сохранен!', type: 'success' })

                state.invalid_item_id = null
                state.is_invalid_date = false
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При попытке оставить ответ произошла ошибка',
                })
            } finally {
                state.is_manage_loading = false
            }
        }

        // computed

        const isDate = (item: OktellWaitListItem) => {
            const status = item.status
            return OKTELL_WAITLIST_STATUSES_WITH_DATE.includes(status.code)
        }
        const isDateInput = (item: OktellWaitListItem) => {
            const status = item.status
            return OKTELL_WAITLIST_INPUTS_WITH_DATE.includes(status.code)
        }
        const getWaitListTitle = (item: OktellWaitListItem) => {
            if (!item) {
                return 'Статус не определен ...'
            }

            const status_string = item.status ? item.status.name : 'Статус'

            const value: string = item.value
            const date_string = isDate(item) ? value : ''

            return `${status_string} ${date_string}`
        }

        //

        onMounted(loadWaitList)

        //

        return {
            state,
            state_date,
            //
            state_form$,
            //
            manageAnswer,
            // confirmDate,
            closeDate,
            //
            getWaitListTitle,
            isDate,
            isDateInput,
            COLUMNS,
        }
    },
})
